import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { IdentityReport, ListElement, MetaStatusCode } from '@core/types/identity-reports';

@Component({
  selector: 'itfg-reports-info-panel',
  templateUrl: './reports-info-panel.component.html',
  styleUrl: './reports-info-panel.component.scss',
  standalone: false,
})
export class ReportsInfoPanelComponent implements OnChanges {
  @Input() listData: ListElement[];
  @Input() reportData: IdentityReport<any>;
  @Input() metaStatusCode: MetaStatusCode | string;
  @Input() reportTime: Date;
  @Input() requesterName: string;
  @Input() requestTime: Date;
  @Input() idCardNumber: string | number | null = null;

  /** Set to false to render the new compact strip layout */
  @Input() legacy = true;

  @Output() dataChanged = new EventEmitter<any>();

  readonly currentDate = new Date();
  readonly twoMontsMiliseconds = 1000 * 60 * 60 * 24 * 30 * 2;

  isStale = false;

  ngOnChanges(): void {
    this.isStale =
      !!this.requestTime &&
      this.requestTime.getTime() + this.twoMontsMiliseconds < this.currentDate.getTime();
  }

  compareItemsById(a: any, b: any): boolean {
    return !!a && !!b && a.id === b.id;
  }

  selectReport(report: ListElement): void {
    this.reportData = report as any;
    this.dataChanged.emit({ value: report });
  }

  /** kept for legacy mat-select path */
  listDataChanged(event: any): void {
    this.dataChanged.emit(event);
  }
}